/* eslint-disable curly */
import { Injectable } from '@angular/core';
import { BaseClass } from '../../../shared/base-class';
import { EntityRiskData } from './entity-risk.data';
import Utils from '../../../shared/utilities/utils';
import { RenewalService } from '../../../core/services/submission/renewal/renewal.service';
import { takeUntil } from 'rxjs/operators';
import { RenewalStatusCode } from '../../../shared/models/data/dto/submission-list/entity-submission-list.dto';
import NotifUtils from '../../../shared/utilities/notif-utils';
import { PolicySummaryData } from '../../policy-management/data/policy-summary.data';
import { stateConstants } from 'app/states/la/shared/constants/state.contant';

@Injectable({
  providedIn: 'root',
})
export class RenewalTermData extends BaseClass {
  constructor(
    public entityRiskData: EntityRiskData,
    public renewalService: RenewalService,
    public policySummaryData: PolicySummaryData
  ) {
    super();
  }

  isForRescindConvertedRenewalProcess(
    isPending: boolean,
    isOffered: boolean,
    isRescinded: boolean
  ): boolean {
    return (
      this.isForConvertedRenewalTerm() &&
      (isPending || /*isOffered ||*/ isRescinded)
    );
  }

  isForConvertedRenewalTerm(): boolean {
    return this.entityRiskData?.EntityRisk?.risks[0]?.isRollOver && this.entityRiskData.getRisk()?.riskStateCode === stateConstants.stateCode;
  }

  rescindConvertedRenewal(): void {
    Utils.blockUI();
    this.renewalService
      .putRescindRenewal(this.entityRiskData?.getRiskId())
      .pipe(takeUntil(this.stop$))
      .subscribe(
        (renewalStatusCode: RenewalStatusCode) => {
          this.setStatusForDisplay(renewalStatusCode);
          Utils.unblockUI();
        },
        (error) => {
          Utils.unblockUI();
          NotifUtils.showError(error.message);
        }
      );
  }

  reverseRescindConvertedRenewal(): void {
    Utils.blockUI();
    this.renewalService
      .putReverseRescindRenewal(this.entityRiskData?.getRiskId())
      .pipe(takeUntil(this.stop$))
      .subscribe(
        (renewalStatusCode: RenewalStatusCode) => {
          this.setStatusForDisplay(renewalStatusCode);
          Utils.unblockUI();
        },
        (error) => {
          Utils.unblockUI();
          NotifUtils.showError(error.message);
        }
      );
  }

    setStatusForDisplay(renewalStatus: RenewalStatusCode): void {
    this.policySummaryData.renewalStatusCode = renewalStatus;
    this.policySummaryData.renewalCode = renewalStatus;
  }
}
